module.exports = __webpack_public_path__ + "static/pear_gif-f4ba10d7ad3e120f0819d2fe37b96692.gif";